import { useEffect, useMemo, useRef, useState } from "react";
import * as THREE from "three";
import { MaterialPreviewRendererInstance } from "./MaterialPreviewRenderer";
import MaterialAsset from "../../classes/MaterialAsset";

export default function MaterialLivePreview({materialId, forcedHeight, properties}: {materialId: string, forcedHeight?: number, properties: any})
{
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const [livePreviewRenderer, setLivePreviewRenderer] = useState<MaterialPreviewRendererInstance | null>(null);
	const material = useMemo(() => MaterialAsset.getMaterialAssetByGuid(materialId)?.internalMaterial, [materialId, properties]);

	useEffect(() => 
	{
		if (!canvasRef.current || process.env.JEST_WORKER_ID) return;
		const livePreviewRenderer = new MaterialPreviewRendererInstance(canvasRef.current);
		let renderer: THREE.WebGLRenderer | null = null;
		livePreviewRenderer.initializeIfNeeded().then(() =>
		{
			renderer = livePreviewRenderer.getRenderer();
		});
		const resize = () => 
		{
			if (!renderer || !canvasRef.current) return;
			const rect = canvasRef.current.getBoundingClientRect();
			renderer.setSize(rect.width, rect.height);
			livePreviewRenderer.renderScene();
		};
		const resizeObserver = new ResizeObserver(resize);
		resizeObserver.observe(canvasRef.current);


		setLivePreviewRenderer(livePreviewRenderer);

		return () =>
		{
			if (livePreviewRenderer)
			{
				livePreviewRenderer.cleanup();
				setLivePreviewRenderer(null);
			}
			resizeObserver.disconnect();
		};
	}, []);

	useEffect(() =>
	{
		if (!livePreviewRenderer || !material) return;
		livePreviewRenderer.setMaterial(material);
		livePreviewRenderer.renderScene();
	}, [livePreviewRenderer, material, properties]);

	return <canvas ref={canvasRef} className="materialPreviewRenderer" style={{ height: forcedHeight ? `${forcedHeight}px` : undefined }} />
}